class ComponentRedeemSlider extends HTMLElement {
    constructor() {
        super();     

        // internal
        this.carousel = null;
        this.sliderWrapper = this.querySelector('.keen-slider-wrapper .keen-slider');
        this.waitForLoyaltylion(this)
        
    }
    initCarousel() {    
        this.carousel = new KeenSlider(this.sliderWrapper, {
            arrows: this.querySelector('.keen-arrows'),
            navBar: this.querySelector('.keen-navbar'),
            mode: "snap",
            loop: false,
            autoplay: 0,
            dots: false,
            prevButton: this.querySelector('.keen-arrow.prev'),
            nextButton: this.querySelector('.keen-arrow.next'),
            spacing: 20,
            breakpoints: {
              '(min-width: 901px)': {
                slidesPerView: this.dataset.size
              },
              '(min-width: 601px) and (max-width: 900px)': {
                spacing: 15,
                slidesPerView: 1
              },
              '(max-width: 600px)': {                
                slidesPerView: 1
              }
            }
        });        
    }
    clickButton(){
      if(this.sliderWrapper.querySelector('[data-reward]')){
        this.sliderWrapper.querySelectorAll('[data-reward]').forEach((btn) => {
          let rewardButton = this.closest('.main-content').querySelector(`#loyaltylion [data-reward-id="${btn.dataset.reward}"] button`)

          if(rewardButton && rewardButton.classList.contains('lion-action-button--disabled')){
            btn.disabled = true;
            btn.innerHTML = rewardButton.textContent.toLowerCase() === 'paid items required' ? 'add items to cart to redeem' : rewardButton.textContent
          }else{
            btn.disabled = false;
            btn.addEventListener('click', ()=>{
              rewardButton.click()
            })
          }
        
        })
      }
      
    }

    waitForLoyaltylion(t){
      var self = t;
      let limitInterval = 10;
        let interval = setInterval(()=> {
          if (self.closest('.main-content').querySelector(`#loyaltylion .lion-rewards-list .lion-reward-item--product-cart button`)) {     
            setTimeout(() => {
              self.clickButton()
              self.initCarousel()
            }, 2500);     
            
            clearInterval(interval);
          }    
          if(!limitInterval && self.querySelector('.keen-slider-wrapper')){
            self.initCarousel()
            clearInterval(interval);
          }     
          limitInterval--
        }, 500); 
    }
}
customElements.define('redeem-slider', ComponentRedeemSlider);

